var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstrumentalTen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E5EAFF;}\r\n\t.st1{fill:#646464;}\r\n\t.st2{fill:#BFCCFF;}\r\n\t.st3{fill:#80FFFF;}\r\n\t.st4{fill:#7DF894;}\r\n\t.st5{fill:#FDFF20;}\r\n\t.st6{fill:#FFC800;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:#FF9100;}\r\n\t.st9{fill:#F03903;}\r\n\t.st10{fill:#C50700;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2850_",
    className: "st10",
    d: "M255.9,1.7c140.3,0,254,113.7,254,254c0,140.2-113.8,253.9-254,253.9 c-140.3,0-254-113.7-254-253.9C1.9,115.5,115.6,1.7,255.9,1.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M174.1,254.2l-47.1-83h39.8L193,220l5.8,17.1l5.6-17.1l27.3-48.8h36l-48.7,81.3l51.2,87.6h-39.3L200.9,288 l-6.5-17.9l-6.3,17.9l-29.9,52.1h-35.9L174.1,254.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M283,245.6H322v-40.8h28.2v40.8h39.3v26.5h-39.3v41.3H322v-41.3H283V245.6z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstrumentalTen);
export default __webpack_public_path__ + "static/media/InstrumentalTen.9709ed3076a1ed0008b60d8e40297989.svg";
export { ForwardRef as ReactComponent };